import { createAction, createSlice } from "@reduxjs/toolkit";

const getAllStatementsSlice = createSlice({
  name: "getAllStatements",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      state.data = action.payload.data.data;
      state.pagination = action.payload.pagination;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getAllStatementsSlice;
const getAllStatementsAction = createAction(name);

export {
  getAllStatementsAction,
  actions as getAllStatementsActions,
  reducer as getAllStatementsReducer,
};
